import useCustomHook from '@/hooks/useCustomHook';
import { sanitizeTextForComparison } from '@/modules/search/sanitizeTextForComparison';
import { filterItemByTagId } from '@/modules/tags/filterByTagId';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { NavigationContext } from '@/shared/NavigationContext/NavigationContext';
import { useContext, useEffect } from 'react';

export default function useLibraryActivitiesList({ activities }) {
  const globalContext = useContext(GlobalContext);
  const navigationContext = useContext(NavigationContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      filteredActivities: activities.filter(
        (activity) => activity.language == globalContext.state.selectedLanguage
      ),
      searchText: '',
    },
    actions: {
      setSearchText: (e) => {
        console.log('searching for:', e?.target?.value);
        actions.setState({
          searchText: e?.target?.value,
        });
      },
      reset: () => {
        actions.setState({
          searchText: '',
        });
        navigationContext.actions.setSelectedTagId(null);
      },
    },
  });

  useEffect(() => {
    actions.setState({
      filteredActivities: activities.filter(
        (activity) =>
          activity.language == globalContext.state.selectedLanguage &&
          (!state.searchText ||
            sanitizeTextForComparison(activity.name).includes(
              sanitizeTextForComparison(state.searchText)
            ) ||
            sanitizeTextForComparison(activity.englishName).includes(
              sanitizeTextForComparison(state.searchText)
            )) &&
          filterItemByTagId(
            activity,
            'activityTags',
            navigationContext.state.selectedTagId
          )
      ),
    });
  }, [
    activities,
    state.searchText,
    globalContext.state.selectedLanguage,
    navigationContext.state.selectedTagId,
  ]);

  return {
    state: {
      ...state,
      canReset: state.searchText || navigationContext.state.selectedTagId,
    },
    actions,
  };
}
